import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Button } from 'ncoded-component-library';
import CheckcircleIcon from 'icons/Checkcircle.icon';

import './SelectCard.styles.scss';

export type SelectCardOption = {
  title: string;
  price: string;
  list: string[];
};

type SelectCardProps = {
  className?: string;
  isSelected: boolean;
  onClick: () => void;
} & SelectCardOption;

const SelectCard: React.FC<SelectCardProps> = (props) => {
  const { className, title, price, list, isSelected, onClick } = props;

  const classes = classNames(
    'select-card',
    'white-panel',
    { selected: isSelected },
    className,
  );

  const { t } = useTranslation();

  return (
    <div className={classes} onClick={onClick}>
      <p className="title">{t(title)}</p>
      <p className="price">{price}</p>

      <ul>
        {list.map((item) => (
          <li key={item}>
            <CheckcircleIcon />
            {t(item)}
          </li>
        ))}
      </ul>

      <Button
        onClick={onClick}
        iconPosition="right"
        icon={isSelected ? CheckcircleIcon : null}
      >
        {t(isSelected ? 'selected' : 'select')}
      </Button>
    </div>
  );
};

export default SelectCard;
